export const INITIAL_PAGE = '1';

export const DISPLAY_SETTING_BODY_HEIGHT = 464;
export const PREVIEW_ROW_ID = 'preview-row';

export const MAXIMUM_SEARCH_HISTORY_LIMIT = 30;
